import { memo, useLayoutEffect, useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// project imports
import NavItem from "./NavItem";
import NavGroup from "./NavGroup";
import { MenuOrientation } from "config";
import menuItem from "menu-items";
import useConfig from "hooks/useConfig";
import useAuth from "hooks/useAuth";

import { Menu } from "menu-items/widget";
import { HORIZONTAL_MAX_ITEM } from "config";
import { useGetMenu, useGetMenuMaster } from "api/menu";

// ==============================|| SIDEBAR MENU LIST ||============================== //

function MenuList() {
  const downMD = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const { user } = useAuth();

  const {
    state: { menuOrientation },
  } = useConfig();
  const { menuLoading } = useGetMenu();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  const [selectedID, setSelectedID] = useState("");
  const [menuItems, setMenuItems] = useState({ items: [] });

  let widgetMenu = Menu();

  useLayoutEffect(() => {
    const isFound = menuItem.items.some((element) => {
      if (element.id === "group-widget") {
        return true;
      }
      return false;
    });

    // Filter menu items based on user role
    let filteredItems = [...menuItem.items];

    // Filter out admin items if user is not admin
    if (user?.role !== "admin") {
      filteredItems = filteredItems.filter((item) => item.id !== "admin");
    }

    if (menuLoading) {
      filteredItems.splice(1, 0, widgetMenu);
      setMenuItems({ items: [...filteredItems] });
    } else if (!menuLoading && widgetMenu?.id !== undefined && !isFound) {
      filteredItems.splice(1, 1, widgetMenu);
      setMenuItems({ items: [...filteredItems] });
    } else {
      setMenuItems({ items: [...filteredItems] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuLoading, user?.role]);

  // last menu-item to show in horizontal menu bar
  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;

  let lastItemIndex = menuItems.items.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items
      .slice(lastItem - 1, menuItems.items.length)
      .map((item) => ({
        title: item.title,
        elements: item.children,
        icon: item.icon,
        ...(item.url && {
          url: item.url,
        }),
      }));
  }

  const navItems = menuItems.items
    .slice(0, lastItemIndex + 1)
    .map((item, index) => {
      switch (item.type) {
        case "group":
          if (item.url && item.id !== lastItemId) {
            return (
              <List key={item.id}>
                <NavItem
                  item={item}
                  level={1}
                  isParents
                  setSelectedID={() => setSelectedID("")}
                />
                {!isHorizontal && index !== 0 && <Divider sx={{ py: 0.5 }} />}
              </List>
            );
          }

          return (
            <NavGroup
              key={item.id}
              setSelectedID={setSelectedID}
              selectedID={selectedID}
              item={item}
              lastItem={lastItem}
              remItems={remItems}
              lastItemId={lastItemId}
            />
          );
        default:
          return (
            <Typography
              key={item.id}
              variant="h6"
              align="center"
              sx={{ color: "error.main" }}
            >
              Menu Items Error
            </Typography>
          );
      }
    });

  return !isHorizontal ? (
    <Box {...(drawerOpen && { sx: { mt: 1.5 } })}>{navItems}</Box>
  ) : (
    <>{navItems}</>
  );
}

export default memo(MenuList);
